import React, { Component } from 'react';
import { GeckoFields, GeckoIcon } from '../../../../../../components';
import './style.css';


export class Unconfigured extends Component {
    render() {
        return (
            <div>
                <a onClick={this.props.onClick} className="d-flex justify-content-between container">
                    <span className="description"><span style={{marginRight: '10px'}}><GeckoIcon icon="toggle-off" /></span>Not set up</span>
                    <span className="affix">Manage</span>
                </a>
            </div>
        )
    }
}

Unconfigured.defaultProps = {
    onClick: () => {},
}

export default Unconfigured;